

import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Col from 'react-bootstrap/Col';
import { Add } from 'react-ionicons';
import Button from 'react-bootstrap/Button';
import { Build } from 'react-ionicons';
import * as singleActions from '../../store/actions/single';
import Bound from './Bound';
import urls from '../../utils/urls';
import * as dayjs from 'dayjs';
import { NotificationManager } from 'react-notifications';

class JudgeEventTile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      preview: ''
    };
  }
  componentDidMount() {
    if (this.props.data && !this.state.preview) {
      if (this.props.data.image) {
        if (this.props.data.image._id) {
          urls.getS3Url(this.props.data.image.thumb || this.props.data.image.path, this.props.auth.token._id)
          .then((imageUrl) => {
            this.setState({
              preview: imageUrl
            });
          })
          .catch((error) => {
            console.error('Error loading image:', error);
          });
        }
      }
    }
  }

  componentDidUpdate(props) {
    if (this.props.data && !this.state.preview) {
      if (this.props.data.image) {
        if (this.props.data.image._id) {
          urls.getS3Url(this.props.data.image.thumb || this.props.data.image.path, this.props.auth.token._id)
          .then((imageUrl) => {
            this.setState({
              preview: imageUrl
            });
          })
          .catch((error) => {
            console.error('Error loading image:', error);
          });
        }
      }
    }
  }

  getCanJudge = () => {
    if (this.props.registrationEnd) {
      let videoEnd = dayjs.utc(this.props.judgingEnd).add(31, 'hours');
      let videoStart = dayjs.utc(this.props.judgingStart).add(7, 'hours');
      let now = dayjs();

      let diff = now.diff(videoEnd, 'minutes');
      let diff2 = now.diff(videoStart, 'minutes');
      //console.log

      return diff < 0 && diff2 > 0;
    }
  };

  render() {
    return (
      <Col md={4} lg={6} xl={4}>
        <Bound>
          {this.props.more ? (
            <div
              className={'tile-container'}
              onClick={(e) => this.props.history.push(`/app/events`)}
              style={{ background: `rgba(0,0,0,.4)` }}>
              <div className={'tile-gradient'}></div>
              <div className={' text-center tile-symbol'}>
                <Add fontSize={'64px'} />
                <h3 className={'more'}>{this.props.more} More</h3>
              </div>
            </div>
          ) : (
            <div
              className={'tile-container'}
              onClick={(e) => {
                if (this.props.isJudge && this.getCanJudge()) {
                  this.props.history.push(`/app/judge/${this.props.data._id}`);
                } else if (this.props.isTabulator && this.getCanJudge()) {
                  this.props.history.push(`/app/tabulator/${this.props.data._id}`);
                } else {
                  NotificationManager.error('This event is not open for adjudication');
                }
              }}
              style={{
                background: `url(${this.state.preview || this.props.placeholder}), rgba(0,0,0,.2)`
              }}>
              {!this.props.isDash && this.props.data ? (
                this.props.data.admins ? (
                  this.props.data.admins.indexOf(this.props.user.user._id) > -1 ? (
                    <Button
                      variant={'flat'}
                      className={'floating-edit-button'}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        this.props.history.push(`/app/events/${this.props.data._id}`);
                      }}>
                      <Build />
                    </Button>
                  ) : null
                ) : null
              ) : null}
              <div className={'tile-gradient'}></div>

              <div className={'tile-content'}>
                <h4>{this.props.name}</h4>
                <h5>{this.props.date}</h5>
              </div>
            </div>
          )}
        </Bound>
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  setSingle: (d) => {
    dispatch(singleActions.setSingleEntry(d));
  }
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(JudgeEventTile));

class JudgeEventTileContainer extends React.Component {
  render() {
    return <Connected {...this.props} />;
  }
}

export default JudgeEventTileContainer;
